export default __webpack_public_path__ + "static/media/05-BB-(4-2).6c04cea5.jpg";